module.exports = __webpack_public_path__ + "static/media/message.e1aa3ebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/message.jpg
// module id = 786
// module chunks = 0